import { render } from "./filters-new.vue?vue&type=template&id=3ae9561b"
import script from "./filters-new.vue?vue&type=script&lang=js"
export * from "./filters-new.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__